<template>
  <BaseCard class="tw:my-4" :key="selectedAccommodationId">
    <div class="tw:p-6">
      <div
        class="tw:border-b tw:pb-4 tw:border-gray-200 tw:flex tw:justify-between tw:items-start"
        ref="paymentDetails"
      >
        <div>
          <h3 class="tw:text-xl tw:font-bold tw:pb-2">{{ $t('paymentMethods.heading') }}</h3>
          <p class="tw:text-sm">{{ $t('paymentMethods.info') }}</p>
        </div>
      </div>
      <PaymentMethodPreview />
      <BillingInformationPreview :accountData="zuoraAccountData" :hasBillingInfo="!hasNoBillingInfo" />
      <MainButton v-if="!hasNoBillingInfo" @click="onPaymentEditClick" class="tw:mt-4">
        {{ $t('payment_method_edit_cta') }}
      </MainButton>
    </div>
  </BaseCard>
</template>

<script setup lang="ts">
import { onMounted, ref, type Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useQueryClient } from '@tanstack/vue-query'

import BaseCard from '@/components/dashboard/BaseCard.vue'
import BillingInformationPreview from '@/components/billing/paymentMethods/BillingInformationPreview.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import PaymentMethodPreview from '@/components/billing/paymentMethods/PaymentMethodPreview.vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { useZuoraAccount } from '@/components/payment/queries'

const router = useRouter()
const route = useRoute()
const queryClient = useQueryClient()

/** Reference to payment details heading element */
const paymentDetails: Ref<HTMLDivElement | null> = ref(null)

const { zuoraAccountData, hasNoBillingInfo } = useZuoraAccount()

/**
 * Navigate to payment edit page
 */
const onPaymentEditClick = (): void => {
  router.push({
    name: 'billing-edit-payment',
  })
}

/**
 * On mount, invalidate payment queries if returning from edit page
 */
onMounted(() => {
  if (route.query?.['editPayment'] === 'true') {
    queryClient.invalidateQueries({ queryKey: ['paymentDetails'] })
    queryClient.invalidateQueries({ queryKey: ['zuoraAccount'] })
  }
})
</script>
